<template>
	<div>
		<div class="nav_bar">
			<van-nav-bar
				title="添加开票抬头"
				left-arrow
				@click-left="$router.go(-1)"
			/>
		</div>
		<div style="height: 56px;"></div>
		<van-cell-group>
			<van-field
				clearable
				required
				v-model="form.receiverCompanyName"
				label="公司名称"
				placeholder="公司名称"
			/>
			<van-field
				clearable
				required
				v-model="form.receiverCompanyTax"
				label="税号"
				placeholder="纳税人识别号"
			/>
			<van-field
				clearable
				required
				v-model="form.receiverCompanyTel"
				label="电话"
				placeholder="电话"
			/>
			<van-field
				clearable
				required
				v-model="form.receiverCompanyAddr"
				label="注册地址"
				placeholder="注册地址"
			/>
			<van-field
				clearable
				required
				v-model="form.receiverCompanyBank"
				label="开户银行"
				placeholder="开户银行"
			/>
			
			<van-field
				clearable
				required
				v-model="form.receiverCompanyBankAccount"
				label="银行账号"
				placeholder="银行账号"
			/>

		</van-cell-group>
		<div style=" padding: 32px 16px 0 16px;">
		    <van-button round block type="primary" color="#2f86f6" :disabled="submitLoading" :loading="submitLoading" @click="onSubmit">提 交</van-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'title_add',
		data() {
			return {
				form : {},
				submitLoading : false
			}
		},
		mounted() {
		},
		methods: {

			onSubmit(){
				if( !this.form.receiverCompanyName ){
					this.$toast('请输入公司名称');
					return false;
				}
				if( !this.form.receiverCompanyTax ){
					this.$toast('请输入纳税人识别号');
					return false;
				}
				if( !this.form.receiverCompanyTel ){
					this.$toast('请输入电话');
					return false;
				}
				if( !this.form.receiverCompanyAddr ){
					this.$toast('请输入注册地址');
					return false;
				}
				
				if( !this.form.receiverCompanyBank ){
					this.$toast('请输入开户银行');
					return false;
				}
				if( !this.form.receiverCompanyBankAccount ){
					this.$toast('请输入银行账号');
					return false;
				}
				
				this.submitLoading = true;
				this.$post('/gtb/invoice/addInvoiceReceive.html', this.form ).then(res=>{
					this.submitLoading = false;
					if( res.success ){
						this.$toast.success(res.msg);
						this.$router.go(-1);
					}else{
						this.$dialog({
							title : '提示',
							message: res.msg,
						});
					}
				}).catch((res) => {
					this.submitLoading = false;
				});
				
			}
		},
	}
</script>
<style scoped>

</style>
